import React, { Fragment } from 'react';
import './locale-toggle.scss';

import { getLocale } from '@edx/frontend-platform/i18n';
import { getConfig } from '@edx/frontend-platform';

import PropTypes from 'prop-types';

const locales = Object.entries({
  ru: 'Ru',
  en: 'En',
});

const getSwitchLocaleUrl = (locale) => `${getConfig().SSO_SWITCH_LOCALE_URL}/${locale}?next=${
  encodeURIComponent(global.location.href)
}`;

const LocaleToggle = ({ className, isGlobeVisible }) => {
  const currentLocale = getLocale();

  return (
    <div className={`locale-toggle ${className}`}>
      {isGlobeVisible && <span className="fa fa-globe" aria-hidden="true" />}
      {locales.map(([code, label], index) => (
        <Fragment key={code}>
          <span className="locale-toggle__item">{
            currentLocale.includes(code)
              ? label
              : <a href={getSwitchLocaleUrl(code)}>{label}</a>
          }
          </span>
          {index !== locales.length - 1 && ' | '}
        </Fragment>
      ))}
    </div>
  );
};

LocaleToggle.propTypes = {
  isGlobeVisible: PropTypes.bool,
  className: PropTypes.string,
};

LocaleToggle.defaultProps = {
  isGlobeVisible: true,
  className: undefined,
};

export default LocaleToggle;
